import { render, staticRenderFns } from "./ThemeDetailsInnerForm.vue?vue&type=template&id=2f8365e7"
import script from "./ThemeDetailsInnerForm.vue?vue&type=script&lang=js"
export * from "./ThemeDetailsInnerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports